import { DocumentRevision } from '@/entities/Document';
import { useSearch } from '@/shared/lib';
import { useSearchService } from '@/shared/lib';
import { search } from '@/entities/Document';
import { SearchParams } from '@/shared/lib';

type UseSearchReturn = ReturnType<typeof useSearch<DocumentRevision>>;

export default function useDocumentRevisionSearch(
  params: SearchParams
): UseSearchReturn & { removeRevisions: UseSearchReturn['removeItems'] } {
  const searchService = useSearchService<DocumentRevision>({
    searchUrl: params.searchUrl,
    context: params.context,
    searchFunction: search,
  });

  const searchFunction = async (searchParams: SearchParams) => {
    await searchService.searchItems(searchParams);
    return {
      data: searchService.items.value,
      metadata: searchService.metadata.value,
    };
  };

  const searchComposable = useSearch<DocumentRevision>({
    ...params,
    // O spread congelaria a URL na criacao do composable, e a aba de Registro le outra fonte que a
    // aba de Documentos. Este getter faz cada consulta ler o endereco da aba ativa.
    get searchUrl() {
      return params.searchUrl;
    },
    searchFunction,
    skipShowAllPrefetch: true,
  });

  return {
    ...searchComposable,
    removeRevisions: searchComposable.removeItems,
  };
}
